<template>
  <div class="Body">
    <div v-for="item in List" :key="item.id">
      <template v-if="item.type_id == '2'">
        <div class="BodyCenter"
          :style="{
              backgroundImage: 'url(' + item.bg_image + ')',
              backgroundSize: '100% ',
            }"
        >
          <div class="body-box">
            <div class="BodyCenter-title">
              <div class="title-one">{{item.title}}</div>
              <div class="title-two">{{item.sub_title}}</div>
            </div>
            <div class="Img1">
              <div
                class="left"
                v-for="(i, index) in item.special_item"
                :key="i.id"
              >
              <img :src="i.bg_image" alt="" />
              <div>
                <sapn class="kuai"></sapn>
                <p class="p1">{{ i.title }}</p>
              </div>
              <p class="p2">{{ i.sub_title }}</p>
              <p class="p3">0{{ index + 1 }}</p>
              <p class="p4"></p>
            </div>
            </div>
            
          </div>
        </div>
      </template>
      <template v-else-if="item.type_id == '5'">
        <div class="two-container"
          :style="{
              backgroundImage: 'url(' + item.bg_image + ')',
              backgroundSize: '100% ',
            }"
        >
          <div class="two-box">
            <div class="two-title">
              <div class="two-title1">{{item.title}}</div>
              <div class="two-subtitle">{{item.sub_title}}</div>
            </div>
            <div class="two-content" v-html="item.content">

            </div>
          </div>
        </div>
      </template>
      <template v-else-if="item.type_id == '1'">
        <div class="Img2">
          <img :src="item.bg_image" alt="" />
        </div>
      </template>
      <template v-else-if="item.type_id == '4'">
        <div
          class="story"
          :style="{
            backgroundImage:
              item.title == null ? 'url(' + item.bg_image + ')' : '',
            backgroundSize: '100%',
          }"
        >
          <div
            class="four wow animated fadeInUp"
            data-wow-duration="1s"
            data-wow-delay=".5s"
            :style="{ display: item.title == null ? 'none' : 'block' }"
          >
            {{ item.title == null ? "" : item.title }}
          </div>
          <div
            class="yi wow animated fadeInUp"
            data-wow-duration="2s"
            data-wow-delay=".5s"
            :style="{ display: item.title == null ? 'none' : 'block' }"
          ></div>
          <div class="storyCenter">
            <div class="LR">
              <div
                class="Left wow animated fadeInUp"
                data-wow-duration="2s"
                data-wow-delay=".5s"
                v-html="item.content"
              ></div>
              <div
                class="right wow animated fadeInUp"
                data-wow-duration="2s"
                data-wow-delay=".5s"
              >
                <img :src="item.oth_image ? item.oth_image.split(',')[0] :''" alt="" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="item.type_id == '3'">
        <div
          class="Safeguard"
          :style="{
            backgroundImage: 'url(' + item.bg_image + ')',
            backgroundSize: '100%',
          }"
        >
          <div class="SafeguardCenter">
            <div class="SafeguardTop">
              <div class="SafeguardTopP1">{{ item.title }}</div>
              <div class="SafeguardTopP2">{{ item.sub_title }}</div>
            </div>
            <div class="SafeguardBottom">
              <div
                class="SafeguardBottomLeft"
                v-for="(i, index) in item.special_item"
                :key="i.id"
              >
                <img :src="i.bg_image" alt="" />
                <div class="SafeguardBottomLeftP1">
                  {{ i.title }}
                </div>
                <div class="SafeguardBottomLeftP2">
                  {{ i.sub_title }}
                </div>
                <div class="SafeguardBottomLeftP3">0{{ index + 1 }}</div>
                <div class="SafeguardBottomLeftHr"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="item.type_id == '6'">
        <div
          class="Btm"
          :style="{
            backgroundImage: 'url(' + item.bg_image + ')',
            backgroundSize: '100%',
          }"
        >
          <div class="BtmCenter">
            <div class="BtmTop">
              <div class="BtmTopRight" style="">
                <div class="BtmLeft">
                  <img :src="item.oth_image ? item.oth_image.split(',')[0] :''"/>
                </div>
                <div class="BtmTopRightP1" v-html="item.content"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="item.type_id == '8'">
        <div class="vid">
          <div class="vidCenter">
            <div
              class="four wow animated fadeInUp"
              data-wow-duration="1s"
              data-wow-delay=".5s"
            >
              {{ item.title }}
            </div>
            <div
              class="yi wow animated fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay=".5s"
            ></div>
            <div
              class="video wow animated slideInUp"
              data-wow-duration="1s"
              data-wow-delay=".5s"
            >
              <video
                :src="item.oth_image? item.oth_image.split(',')[0] :''"
                alt=""
                controls
                loop
                :poster="item.bg_image"
                @click="SHOW(item.bg_image)"
                style="width= 100%; height=100%; object-fit: fill"
              />
              <img
                v-show="bofang"
                class="bofang"
                src="../../assets/about/bofang-3.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="item.type_id == '9'">
        <div class="honor">
          <div class="honorCenter">
            <div
              class="four wow animated fadeInUp"
              data-wow-duration="1s"
              data-wow-delay="0s"
            >
              {{ item.title }}
            </div>
            <div
              class="yi wow animated fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="0s"
            ></div>
            <div class="Bighonor">
              <div
                class="one wow animated fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay=".5s"
                v-for="i in item.special_item"
                :key="i.id"
              >
                <img :src="i.bg_image" alt="" />
                <p class="p1">{{ i.title }}</p>
                <p class="p2">{{ i.sub_title }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="item.type_id == '10'">
        <div class="data">
          <div class="dataCenter">
            <div
              class="img"
              :style="{
                backgroundImage: 'url(' + item.bg_image + ')',
                backgroundSize: '100%',
              }"
            >
              <div class="bigP">
                <div class="bigP_One">
                  <div class="P1" v-for="i in item.special_item" :key="i.id">
                    <p class="p11">{{ i.title }}</p>
                    <p class="p12 wow">
                      {{ i.sub_title.substr(0, i.sub_title.length - 1) }}
                      <span class="SmallSpan">
                        {{
                          i.sub_title.substr(
                            i.sub_title.length - 1,
                            i.sub_title.length
                          )
                        }}</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="item.type_id == '7'">
        <div class="StoryCenter">
          <div
            class="Img"
            :style="{
              backgroundImage: 'url(' + item.bg_image + ')',
            }"
          >
            <div class="wenzi">
              <p
                class="p1 wow animated bounceInUp"
                data-wow-duration="1s"
                data-wow-delay=".1s"
              >
                {{ item.title }}
              </p>
              <p
                class="p2 wow animated bounceInUp"
                data-wow-duration="1.5s"
                data-wow-delay=".2s"
              >
                {{ item.sub_title }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { GetDetails } from "@/https/http";
export default {
  data() {
    return {
      List: "",
      Banner: "",
      TIBP: "",
      WidthImg: "",
      bofang: false,
    };
  },
  methods: {
    SHOW() {
      var player = document.getElementById("player");
      if (player.play) {
        player.pause();
      } else {
        this.bofang = !this.bofang;
        player.play();
      }
    },
  },
  created() {
    GetDetails({
      cid: this.$route.query.id,
      id: this.$route.query.id,
      modular: this.$route.query.modular,
    }).then((res) => {
      console.log(res,'专题列表')
      this.List = res.result.special;
    });
  },
};
</script>
<style lang="scss" scoped>
.p12 {
  color: #999;
}
* {
  padding: 0;
  margin: 0;
}
@media screen and(min-width: 1020px){
  .Body {
  width: 100%;
  .BodyCenter {
    width: 100%;
    min-width: 1440px;
    min-height: 900px;
    margin: 0 auto;
    .body-box{
      width: 1440px;
      margin:0 auto;
      min-width: 1440px;
      min-height: 900px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .BodyCenter-title{
        padding-top:110px;
        width: 1440px;
        margin:0 auto;
        text-align: center;
        .title-one{
          font-size: 40px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #62A591;
          line-height: 30px;
        }
        .title-two{
          margin-top:20px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #62A591;
          line-height: 30px;
        }
      }
      .Img1 {
        width: 1440px;
        display: flex;
        justify-content: space-between;
        padding-top: 110px;
      .left {
        width: 398px;
        margin-left: 2px;
        img {
          width: 398px;
          height: 298px;
        }
        .kuai {
          width: 10px;
          height: 20px;
          background: #62a591;
          opacity: 0.6;
          margin-top: 6px;
          margin-left: 35px;
          margin-right: 19px;

          float: left;
        }
        .p1 {
          height: 31px;
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1a1a1a;
          line-height: 27px;
          margin-top: 50px;
        }
        .p2 {
          width: 120px;
          height: 50px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 30px;
          margin-left: 65px;
          margin-top: 18px;
        }
        .p3 {
          width: 45px;
          height: 30px;
          font-size: 40px;
          font-family: FZChaoCuHei-M10S;
          font-weight: 400;
          color: #d7e5e0;
          line-height: 27px;
          margin-left: 320px;
          margin-top: -12px;
        }
        .p4 {
          width: 400px;
          height: 4px;
          background: linear-gradient(90deg, #62a591, #62a591, #ffffff);
          border-radius: 2px;
          margin-top: 31px;
        }
      }
    }
    
    }
  }
  .Img2 {
    width: 100%;
    min-width: 1440px;
    min-height: 702px;
    margin: 0 auto;
    /* margin-top: 207px; */
    /* margin-top: -209px; */

    img {
      width: 100%;
      height: 100%;
    }
  }
  .story {
    width: 100%;
    height: 790px;

    min-width: 1440px;
    .four {
      width: 123px;
      height: 30px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      overflow: hidden;
      margin: 148px auto;
      margin-bottom: 19px;
    }
    .yi {
      width: 100px;
      height: 3px;
      background: linear-gradient(270deg, #fad126, #ff8229);
      border-radius: 0px;
      margin-top: 19px;
      margin: 0 auto;
    }
    .storyCenter {
      height: 450px;
      width: 1400px;
      margin: 0 auto;
      margin-top: 30px;
      .LR {
        height: 450px;
        /* float: left; */
        display: flex;
        justify-content: space-between;
        .Left {
          margin-top: 84px;
          width: 538px;
          float: left;
          height:100%;
          overflow: hidden;
        }
        .right {
          width: 600px;
          height: 400px;
          margin-right: 0px;
          float: right;
          img {
            width: 605px;
            z-index: 1;
          }
        }
      }
    }
  }

  .Safeguard {
    height: 937px;
    background: #eff6f3;
    .SafeguardCenter {
      width: 1400px;
      margin: 0 auto;
      .SafeguardTopP1 {
        /* width: 160px; */
        height: 40px;
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #62a591;
        line-height: 30px;
        text-align: center;
        padding-top: 91px;
      }
      .SafeguardTopP2 {
        /* width: 359px; */
        height: 25px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #62a591;
        line-height: 30px;
        text-align: center;
        margin-top: 20px;
      }
      .SafeguardBottom {
        height: 510px;
        margin-top: 112px;
        display: flex;
        justify-content: space-between;
        .SafeguardBottomLeft,
        .SafeguardBottomCenter,
        .SafeguardBottomRight {
          width: 400px;
          height: 510px;
          img {
            width: 400px;
          }
          .SafeguardBottomLeftP1 {
            height: 31px;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1a1a1a;
            line-height: 27px;
            margin-top: 51px;
            margin-left: 67px;
          }
          .SafeguardBottomLeftP2 {
            /* width: 120px; */
            height: 50px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            line-height: 30px;
            margin-left: 66px;
            margin-top: 18px;
          }
          .SafeguardBottomLeftP3 {
            /* width: 45px; */
            height: 30px;
            font-size: 40px;
            font-family: FZChaoCuHei-M10S;
            font-weight: 400;
            color: #5fa38c;
            line-height: 27px;
            margin-top: -12px;
            margin-left: 321px;
          }
          .SafeguardBottomLeftHr {
            width: 400px;
            height: 4px;
            background: #62a591;
            margin-top: 40px;
          }
        }
      }
    }
  }
  .Btm {
    width: 100%;
    min-width:1400px;
  }
  .BtmCenter {
    width: 1400px;
    margin: 0 auto;
    .BtmTop {
      width: 1400px;
      height: 800px;
      // margin-left: -227px;
      img {
        // position: absolute;
        // z-index: -1;
      }
      .BtmTopRight {
        // width: 549px;
        width:1400px;
        display:flex;
        justify-content: space-between;
        height: 800px;
        align-items: center;
        .BtmTopRightP1 {
          width: 580px;
          height: 40px;
          // margin-left: 439px;
          // margin-top: 129px;
        }
        .BtmTopRightP2 {
          width: 549px;
          height: 64px;
          margin-left: 439px;
          margin-top: 75px;
        }
      }
    }
    .BtmBottom {
      margin-top: 238px;
      img {
        margin-left: 838px;
        position: absolute;
      }
      .BtmBottomRight {
        position: relative;
        width: 552px;
        top: 228px;
        left: 143px;
        margin-top: 228px;
      }
      .BtmBottomRightP1 {
        width: 422px;
        height: 40px;
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #4d4d4d;
        line-height: 60px;
      }
      .BtmBottomRightP2 {
        width: 552px;
        height: 105px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #4d4d4d;
        line-height: 40px;
        margin-top: 74px;
      }
    }
    .qiu {
      width: 300px;
      height: 300px;
      background: #cfe3dc;
      border-radius: 50%;
      margin-left: 2px;
      margin-top: 49px;
    }
  }
  .vid {
    width: 100%;
    .vidCenter {
      width: 1400px;
      min-width: 1440px;
      margin: 0 auto;
      .four {
        width: 123px;
        height: 30px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        margin-left: 46.93%;
        margin-top: 148px;
      }
      .yi {
        width: 100px;
        height: 3px;
        background: linear-gradient(270deg, #fad126, #ff8229);
        border-radius: 0px;
        margin-left: 47.24%;
        margin-top: 19px;
      }
      .video {
        width: 1400px;
        height: 600px;
        margin-top: 60px;
        position: relative;
        video {
          width: 1400px;
          height: 600px;
        }
        img {
          width: 100%;
        }
        .bofang {
          width: 78px;
          height: 78px;
          position: absolute;
          top: 44%;
          left: 46%;
        }
      }
    }
  }
  .honor {
    width: 100%;
    .honorCenter {
      width: 1400px;
      margin: 0 auto;
    }
    .four {
      width: 123px;
      height: 30px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      margin-left: 46.93%;
      margin-top: 148px;
    }
    .yi {
      width: 100px;
      height: 3px;
      background: linear-gradient(270deg, #fad126, #ff8229);
      border-radius: 0px;
      margin-left: 47.24%;
      margin-top: 19px;
      margin-bottom: 44px;
    }
    .Bighonor {
      display: flex;
      .one {
        width: 100%;
      }
      img {
        width: 100%;
        cursor: pointer;
      }
      .p1 {
        width: 128px;
        height: 19px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        margin: 0 auto;
        margin-bottom: 9px;
        cursor: pointer;
        text-align: center;
      }
      .p2 {
        width: 200px;
        height: 17px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        margin: 0 auto;
        margin-bottom: 74px;
        cursor: pointer;
      }
    }
  }
  .data {
    width: 100%;
    min-width: 1440px;
    height: 360px;
    margin-top: 55px;
    .dataCenter {
      width: 100%;
      height: 360px;
      min-width: 1440px;
      margin: 0 auto;
      .img {
        min-width: 1440px;
        z-index: 0;
        background-position: center center;
        width: 100%;
        height: 360px;
        margin: 0 auto;
        position: absolute;
        .bigP {
          width: 1400px;
          min-width: 1440px;
          height: 200px;
          margin: 0 auto;
          position: relative;
          top: 135px;
          left: 0;
          .bigP_One {
            width: 1300px;
            height: 200px;
            /* display: flex; */
            /* justify-content: center; */
            /* align-items: center; */
            .P1:nth-child(0) {
              margin-left: 0px;
            }
            .P1 {
              float: left;
              width: 150px;
              margin-right: 150px;

              .p11 {
                width: 65px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999;
                line-height: 30px;
                margin-bottom: 20px;
              }
              .p12 {
                width: 180px;
                font-size: 50px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #333;
                line-height: 30px;
                float: left;
                .SmallSpan {
                  width: 15px;
                  height: 14px;
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999;
                  line-height: 30px;
                  margin-left: -15px;
                }
              }
            }
          }
        }
      }
    }
  }
  .StoryCenter {
    width: 100%;
    margin: 0 auto;
    .Img {
      width: 100%;
      height: 937px;
      min-width: 1440px;
      z-index: 0;
      background-position: center center;
      display: flex;
      justify-content: center;
      align-content: center;
      .wenzi {
        width: 809px;
        height: 112px;
        overflow: hidden;
        margin: 0 auto;
        padding-top: 399px;
        .p1 {
          width: 809px;
          /* margin: 0 auto; */
          text-align: center;
          height: 40px;
          font-size: 40px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 30px;
          margin-bottom: 39px;
        }
        .p2 {
          width: 835px;
          height: 32px;
          font-size: 32px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 30px;
        }
      }
    }
  }
  // type_id=5 上文字下图片
  .two-container{
    width: 100%;
    min-width: 1440px;
    min-height: 900px;
    .two-box{
      padding-top:70px;
      box-sizing: border-box;
      width: 1440px;
      margin:0 auto;
      min-width: 1440px;
      min-height: 900px;

      .two-title{
        width: 1440px;
        margin:0 auto;
        text-align: center;
        .two-title1{
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1A1A1A;
          line-height: 30px;
        }
        .two-subtitle{
          margin-top:15px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
        }
      }
      .two-content{
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
      }
    }
  }
}
}
@media screen and(max-width:1020px){
  .BtmLeft{
    display: none;
  }
  .right{
    display:none;
  }
  .Body{
    width: 100%;
    .BodyCenter{
      margin-top:20px;
      width: 100%;
      // typeid 2
      .body-box{
        width:100%;

        .BodyCenter-title{
          margin:0 auto;
          text-align: center;

          .title-one{
            font-size: 40px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #62A591;
            line-height: 30px;
          }
          .title-two{
            margin-top:20px;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #62A591;
            line-height: 30px;
          }
        }
        .Img1{
          width: 100%;
          
          .left{
            width: 100%;
            margin-top:15px;
            img{
              width: 100%;
            }
            .kuai {
              width: 10px;
              height: 20px;
              background: #62a591;
              opacity: 0.6;
              margin-top: 6px;
              margin-left: 35px;
              margin-right: 19px;

              float: left;
            }
            .p1 {
              height: 31px;
              font-size: 30px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #1a1a1a;
              line-height: 27px;
              margin-top: 20px;
            }
            .p2 {
              width: 120px;
              height: 70px;
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 30px;
              margin-left: 65px;
              margin-top: 10px;
            }
            .p3 {
              width: 45px;
              height: 30px;
              font-size: 40px;
              font-family: FZChaoCuHei-M10S;
              font-weight: 400;
              color: #d7e5e0;
              line-height: 27px;
              margin-left: 320px;
              margin-top: -30px;
            }
            .p4 {
              width: 400px;
              height: 4px;
              background: linear-gradient(90deg, #62a591, #62a591, #ffffff);
              border-radius: 2px;
              margin-top: 31px;
            }
          }
        }
      }
    }
    // banner
    .Img2{
      width: 100%;
      img{
        width: 100%;
      }
    }
    // 品牌故事
    .story{
      width: 100%;

      .four{
        width: 123px;
        height: 30px;
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        overflow: hidden;
        margin: 20px auto;
        margin-bottom: 19px;
      }
      .yi{
        width: 100px;
        height: 3px;
        background: linear-gradient(270deg, #fad126, #ff8229);
        border-radius: 0px;
        margin-top: 19px;
        margin: 0 auto;
      }
      .storyCenter{
        width: 100%;
        box-sizing: border-box;
        padding-left:15px;
        padding-right:15px;

        .LR{
          width: 100%;
          .right{
            width:100%;
            img{
              width: 100%;
            }
          }
        }
      }
    }
    // type7 
    .StoryCenter{
      width: 100%;
      margin-top:20px;
      .Img{
        width: 100%;
        height:200px;
        background-position: center center;
        background-size: 100%;
        background-repeat: no-repeat;

        .wenzi{
          width: 100%;
          height:150px;
          overflow: hidden;
          box-sizing: border-box;
          padding:20px;
          padding-top:50px;

          .p1{
            width: 100%;
            text-align: center;
            height: 40px;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 30px;
          }
          .p2 {
            width: 100%;
            height: 50px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 30px;
        }
        }

      }
    }
    // video
    .vid{
      width: 100%;
      .vidCenter{
        width: 100%;
        .four{
          width: 123px;
          height: 30px;
          font-size: 28px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
          margin:0 auto;
          margin-top: 30px;
        }
        .yi {
          width: 100px;
          height: 3px;
          background: linear-gradient(270deg, #fad126, #ff8229);
          border-radius: 0px;
          margin:0 auto;
          margin-top: 19px;
        }
        .video{
          width: 100%;
          margin-top:20px;
          box-sizing: border-box;
          padding-left:10px;
          padding-right:10px;

          video{
            width: 100%;
            // height:200px;
          }
        }
      }
    }
    // honor
    .honor{
      width: 100%;
      .honorCenter{
        width: 100%;
        .four{
          width: 123px;
          height: 30px;
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
          margin:0 auto;
          margin-top: 30px;
        }
        .yi{
          width: 100px;
          height: 3px;
          background: linear-gradient(270deg, #fad126, #ff8229);
          border-radius: 0px;
          margin:0 auto;
          margin-top: 19px;
          margin-bottom: 44px;
        }
        .Bighonor{
          width: 100%;
          display:flex;
          flex-direction: row;
          flex-wrap:wrap;
          .one{
            width: 32%;
            margin-bottom:20px;
            img{
              width: 100%;
            }
            .p1{
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 30px;
              margin: 0 auto;
              margin-bottom: 9px;
              cursor: pointer;
              text-align: center;
            }
            .p2 {
              margin-top:-15px;
              padding-left:15px;
              padding-right:15px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 25px;
              margin: 0 auto;
              cursor: pointer;
            }
          }
        }
      }
    }
    // data数据
    .data{
      width: 100%;
      .dataCenter{
        width: 100%;
        .img{
          width: 100%;
          background-position:center center ;
          background-repeat: no-repeat;

          .bigP{
            width: 100%;
            height: 100px;
            .bigP_One{
              width: 100%;
              height: 100px;
              display: flex;
              align-items: center;
              justify-content: space-around;

              .P1 {
                .p11 {
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999;
                  line-height: 24px;
                }
                .p12 {
                  
                  font-size: 20px;
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  color: #333;
                  line-height: 20px;
                  float: left;
                  .SmallSpan {
                    width: 15px;
                    height: 14px;
                    font-size: 12px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #999;
                    line-height: 20px;
                    
                  }
                }
            }
            }
          }
        }
      }
    }
    // 5上文字下图片
    .two-container{
      width: 100%;
      .two-box{
        overflow: hidden;
        box-sizing: border-box;
        padding-left:15px;
        padding-right:15px;
        margin-top:30px;
        width: 100%;
        text-align: center;
        .two-title1{
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1A1A1A;
          line-height: 30px;
        }
        .two-subtitle{
          margin-top:15px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
        }
        .two-content{
          width: 100%;
          overflow: hidden;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 30px;
          img{
            width: 100%;
          }
        }
      }
    }
    // 3
    .Safeguard{
      width: 100%;
      .SafeguardCenter{
        width: 100%;

        .SafeguardTopP1{
          margin-top:20px;
          padding-top:30px;
          height: 40px;
          font-size: 40px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #62a591;
          line-height: 30px;
          text-align: center;
        }
        .SafeguardTopP2 {
          /* width: 359px; */
          height: 25px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #62a591;
          line-height: 30px;
          text-align: center;
          margin-top: 20px;
      }
      .SafeguardBottom{
        width: 100%;
        margin-top:40px;
        .SafeguardBottomLeft,
        .SafeguardBottomCenter,
        .SafeguardBottomRight {
          width: 100%;
          img{
            width: 100%;
          }
          .SafeguardBottomLeftP1 {
            height: 31px;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1a1a1a;
            line-height: 27px;
            margin-top: 51px;
            margin-left: 67px;
          }
          .SafeguardBottomLeftP2 {
            /* width: 120px; */
            height: 50px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            line-height: 30px;
            margin-left: 66px;
            margin-top: 18px;
          }
          .SafeguardBottomLeftP3 {
            /* width: 45px; */
            height: 30px;
            font-size: 40px;
            font-family: FZChaoCuHei-M10S;
            font-weight: 400;
            color: #5fa38c;
            line-height: 27px;
            margin-top: -12px;
            margin-left: 321px;
          }
          .SafeguardBottomLeftHr {
            width: 100%;
            height: 4px;
            background: #62a591;
            margin-top: 40px;
          }
        }
      }
      }
    }

    .Btm{
      width: 100%;
      background-position: center center;
      background-repeat: no-repeat;
      .BtmCenter{
        box-sizing:border-box;
        padding-left:15px;
        padding-right:15px;
        width: 100%;
        .BtmTop{
          width: 100%;
          img{
            position: absolute;
            z-index: -1;
          }
          .BtmTopRight {
            .BtmTopRightP1 {
              font-size: 24px;
            }
            .BtmTopRightP2 {
            }
          }
        }
      }
    }
    .story{
      width: 100%;
      
    }
  }
}
</style>